import { useEffect } from 'react'
import { usePage } from '@inertiajs/react'
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert"
import { CheckCircle2, XCircle, AlertCircle, Info } from "lucide-react"

interface FlashMessage {
  notice?: string
  alert?: string
  error?: string
}

export function FlashMessage() {
  const { flash } = usePage<{ flash: FlashMessage }>().props

  if (!flash.notice && !flash.alert && !flash.error) {
    return null
  }

  const message = flash.notice || flash.alert || flash.error
  const type = flash.notice ? 'success' : flash.alert ? 'warning' : 'error'

  const icons = {
    success: <CheckCircle2 className="h-4 w-4" />,
    warning: <AlertCircle className="h-4 w-4" />,
    error: <XCircle className="h-4 w-4" />
  }

  const variants = {
    success: "bg-green-50 text-green-800 border-green-200",
    warning: "bg-yellow-50 text-yellow-800 border-yellow-200",
    error: "bg-red-50 text-red-800 border-red-200"
  }

  return (
    <Alert className={`mb-4 ${variants[type]}`}>
      {icons[type]}
      <AlertDescription className="inline-block ml-2">{message}</AlertDescription>
    </Alert>
  )
}
